import './TurboTaxTable.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import Content, { contentConverter } from 'services/Content';
import {
  SERVICE_TYPE_CORE,
  SERVICE_TYPE_MIL,
  SERVICE_TYPE_HNW,
  SERVICE_TYPE_PFD,
  NO_SERVICE_LEVEL
} from 'services/ServiceBenefits';

const TurboTaxTable = ({ accountType }) => {
  const epsTable = (
    <Fragment>
      <p>
        Get your taxes done right and save. As a T. Rowe Price Enhanced Personal
        Services Client, choose among a suite of Free and Discounted TurboTax
        products (see offer details below). TurboTax will help you choose the
        product that best meets your needs.
      </p>
      <table className="table">
        <tbody>
          <tr>
            <td>Free Products</td>
            <td>Discounted Products</td>
          </tr>
          <tr className="table-content">
            <td>
              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.freeTurboTaxBasicDesktop
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.freeTurboTaxDeluxe
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.freeTurboTaxPremierOnline
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.freeTurboTaxOnlineState
                    )
                  }}
                />
              </ul>
            </td>
            <td>
              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.discountedTurboTaxPremierDesktop
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.discountedTurboTaxSelfEmployed
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.discountedTurboTaxBusiness
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.discountedTurboTaxProducts
                    )
                  }}
                />
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        Users of TurboTax may receive offers for additional products or services
        provided by Intuit. These offers are not supplied or endorsed by T. Rowe
        Price.
      </p>
    </Fragment>
  );

  const csTable = (
    <Fragment>
      <p>
        Get your taxes done right and save. As a T. Rowe Price Client, you can
        save up to $20 on TurboTax products (see offer details below).
      </p>
      <p>
        Did you know that TurboTax has a solution just for those with investment
        income? TurboTax Premier covers every type of investment, and, like all
        TurboTax products, it allows you to easily and automatically import tax
        information for your T. Rowe Price accounts.
      </p>
      <table className="table">
        <tbody>
          <tr>
            <td>TurboTax Special Offers</td>
          </tr>
          <tr className="table-content">
            <td>
              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.discountedTurboTaxDeluxe
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.discountedTurboTaxPremier
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.discountedTurboTaxSelfEmployed
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.discountedTurboTaxBusiness
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.discountedTurboTaxProducts
                    )
                  }}
                />
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        Users of TurboTax may receive offers for additional products or services
        provided by Intuit. These offers are not supplied or endorsed by T. Rowe
        Price.
      </p>
    </Fragment>
  );

  const noServiceTable = (
    <Fragment>
      <table className="table">
        <tbody>
          <tr>
            <td>TurboTax Benefits</td>
          </tr>
          <tr className="table-content">
            <td>
              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(Content.turboCPA)
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(Content.turboExpert)
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(Content.turboTime)
                  }}
                />
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </Fragment>
  );

  if (accountType === NO_SERVICE_LEVEL) {
    return noServiceTable;
  }
  if (accountType === SERVICE_TYPE_CORE || accountType === SERVICE_TYPE_PFD) {
    return csTable;
  } else if (
    accountType === SERVICE_TYPE_MIL ||
    accountType === SERVICE_TYPE_HNW
  ) {
    return epsTable;
  }
};

const mapStateToProps = (state) => ({
  isDesktopLayout: state.view.isDesktopLayout
});

export default connect(mapStateToProps)(TurboTaxTable);
